import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { authReducer, IAuthState } from "./reducers/auth.reducer";
import { userReducer, IUserState } from "./reducers/user.reducer";
import { globalReducer, IGlobalState } from "./reducers/global.reducer";
import { Reducer } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { ICampaignState, campaignReducer } from "./reducers/campaign.reducer";
import { appReducer, IAppState } from "./reducers/app.reducer";
import { IReportState, reportReducer } from "./reducers/report.reducer";

export interface IRootState {
  auth: IAuthState;
  user: IUserState;
  global: IGlobalState;
  campaign: ICampaignState;
  app: IAppState;
  report: IReportState;
}

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    global: globalReducer as Reducer<IGlobalState, AnyAction>,
    campaign: campaignReducer,
    app: appReducer,
    report: reportReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
